import axios from "axios";

const instanceTelegram = axios.create({
    baseURL: process.env.REACT_APP_TELEGRAM_API_URL,
    headers: {
      Authorization: ""
    }
  })

export default instanceTelegram;